import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { Wordmark } from "./Motion";
import { useCart } from "../context/CartContext";

const LINKS = [
  { to: "/shop", label: "Shop" },
  { to: "/shop", label: "New Drop" },
  { to: "/donate", label: "Donate" },
  { to: "/lookbook", label: "Lookbook" },
  { to: "/our-story", label: "Our Story" },
  { to: "/mission", label: "Mission" },
  { to: "/contact", label: "Contact" },
];

export const Nav = () => {
  const { count, setOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const [menu, setMenu] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);
  useEffect(() => { setMenu(false); }, [loc.pathname]);

  return (
    <header
      data-testid="main-nav"
      className={`sticky top-0 z-50 transition-colors duration-300 border-b ${
        scrolled ? "bg-bg/85 backdrop-blur-md border-line" : "bg-transparent border-transparent"
      }`}
    >
      <nav className="max-w-[1500px] mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <button className="lg:hidden" onClick={() => setMenu(!menu)} data-testid="mobile-menu-btn" aria-label="Menu">
            {menu ? <X size={22} /> : <Menu size={22} />}
          </button>
          <Link to="/" data-testid="nav-logo">
            <Wordmark className="text-xl sm:text-2xl" />
          </Link>
        </div>

        <div className="hidden lg:flex items-center gap-7 font-mono text-[11px] uppercase tracking-[0.18em]">
          {LINKS.map((l, i) => (
            <Link key={i} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className="text-cream/70 hover:text-cream transition-colors duration-200">
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-5 font-mono text-[11px] uppercase tracking-[0.18em]">
          <Link to="/account" data-testid="nav-account" className="hidden sm:inline text-cream/70 hover:text-cream transition-colors duration-200">
            Account
          </Link>
          <button onClick={() => setOpen(true)} data-testid="nav-cart-btn" className="relative flex items-center gap-2 hover:opacity-70 transition-opacity duration-200">
            <ShoppingBag size={18} />
            <span className="tabular-nums">{count}</span>
          </button>
        </div>
      </nav>

      {menu && (
        <div className="lg:hidden bg-bg border-t border-line px-6 py-6 flex flex-col gap-5 font-mono text-sm uppercase tracking-[0.18em]" data-testid="mobile-menu">
          {[...LINKS, { to: "/account", label: "Account" }].map((l, i) => (
            <Link key={i} to={l.to} className="text-cream/80">{l.label}</Link>
          ))}
        </div>
      )}
    </header>
  );
};
